<script setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";

import ClassQuizBasePrompt from "@/components/vocabularyTrainer/ClassQuizBasePrompt.vue";

const props = defineProps({
  correct: {
    type: Boolean,
    required: true
  }
});

const { t } = useI18n();
</script>

<template>
  <ClassQuizBasePrompt class="text-center">
    <AbcHeading v-if="props.correct" tag="h1" size="xl" color="primary">
      {{ t("vocab.classQuiz.question.correctPromptHeading") }}
    </AbcHeading>
    <AbcHeading v-else tag="h1" size="xl" color="red">
      {{ t("vocab.classQuiz.question.wrongPromptHeading") }}
    </AbcHeading>
  </ClassQuizBasePrompt>
</template>
